import React from "react";
import { Route, Switch, Redirect, HashRouter } from "react-router-dom";
import { ThemeProvider } from '@material-ui/styles';
import "../styles/App.css";
import AuthContainer from "./Auth/AuthContainer";
import RegisterContainer from "./Auth/RegisterContainer";
import PrivateRoute from "./PrivateRoute";
import LkContainer from "./Lk/LkContainer";
import theme from "../styles/MuiTheme";
import { UserProvider } from "../UserContext";
import AgreementContainer from "./Agreement/AgreementContainer";
import ForgotContainer from "./Auth/ForgotContainer";

const Lk = () => (
    <UserProvider>
        <LkContainer />
    </UserProvider>
)

const App = () => {

    return (
        <HashRouter >
            <ThemeProvider theme={theme}>
                <div style={{ zIndex: 1 }}>
                    <Switch>
                        <Route path={`${process.env.REACT_APP_WEBSITE_NAME}/auth`}>
                            <AuthContainer />
                        </Route>
                        <Route path={`${process.env.REACT_APP_WEBSITE_NAME}/register`}>
                            <RegisterContainer />
                        </Route>
                        <Route path={`${process.env.REACT_APP_WEBSITE_NAME}/forgot/:step`}>
                            <ForgotContainer />
                        </Route>
                        <Route path={`${process.env.REACT_APP_WEBSITE_NAME}/agreement`}>
                            <AgreementContainer />
                        </Route>
                        <PrivateRoute path={`${process.env.REACT_APP_WEBSITE_NAME}/lk`} component={Lk} />
                        <Redirect from="*" to={`${process.env.REACT_APP_WEBSITE_NAME}/auth`} />
                        <Route component={AuthContainer} />
                    </Switch>
                </div>
            </ThemeProvider>
        </HashRouter>
    );
};

export default App;
